import { render } from "./index.vue?vue&type=template&id=adbc800e&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=adbc800e&scoped=true&lang=css"

import exportComponent from "/builds/root/dev.front.widget/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-adbc800e"]])

export default __exports__